import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Button,
} from 'reactstrap';

const rocket = `${process.env.PUBLIC_URL}/img/pricing_cards/001-rocket.svg`;

const CardPremium = ({ t }) => (
  <Col md={6} xl={3} sm={12}>
    <Card>
      <CardBody className="pricing-card pricing-card--danger">
        <div className="pricing-card__body">
          <img className="pricing-card__img" src={rocket} alt="" />
          <h3 className="pricing-card__plan">{t('card_premium.premium')}</h3>
          <hr />
          <p className="pricing-card__price">{t('card_premium.dollar')}<span>{t('card_premium./mo')}</span></p>
          <p className="pricing-card__feature">{t('card_premium.users')} </p>
          <p className="pricing-card__feature">{t('card_premium.storage')}</p>
          <p className="pricing-card__feature">{t('card_premium.m_update')}</p>
          <p className="pricing-card__feature">{t('card_premium.support')}</p>
          <Button className="pricing-card__button" color="primary">{t('card_premium.sign_up')}</Button>
        </div>
      </CardBody>
    </Card>
  </Col>
);

CardPremium.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation('common')(CardPremium);
